import axios from 'axios'
import urls from '../common/js/urls.js'

export function info_main() {
  return new Promise(function (resolve, reject) {
    var application_id = 1;
    var url = urls.infomation_list_home + "?category_id=11&pageNum=1&pageSize=20&application_id=" + application_id;
    axios.get(url).then(function (res) {
      resolve(res.data)
    }).catch((response) => {
      reject(response);
    })
  });
}

export function api_info_article(category_id, pageNum, area_id) {
  return new Promise(function (resolve, reject) {
    var application_id = 1;
    var url = urls.infomation_list_by_type + "?category_id=" + category_id + "&pageNum=" + pageNum + "&pageSize=20&application_id=" + application_id;
    if(area_id.length !== 0){
      url = url + "&area_id=" + area_id;
    }
    axios.get(url).then(function (res) {
      resolve(res.data.category)
    }).catch((response) => {
      reject(response);
    })
  });
}

export function upload_read_num(article_id){
  return new Promise(function (resolve, reject) {
    var url = urls.upload_article_read + "?aid=" + article_id;
    axios.post(url).then(function (res) {
    }).catch((response) => {
    })
  });
}








// WEBPACK FOOTER //
// ./src/networks/InfoArticleHandler.js